import { Provider } from '@angular/core';
import { AppConfig } from '../types/app-config';

export class ConfigService implements AppConfig {

  public readonly BASE_URL: string;
  public readonly COMMIT: string;
  public readonly VERSION: string;
  public readonly SENTRY_ENVIRONMENT: string;
  public readonly ENV_LABEL?: string;

  constructor(config: AppConfig) {
    this.BASE_URL = config.BASE_URL;
    this.COMMIT = config.COMMIT;
    this.VERSION = config.VERSION;
    this.SENTRY_ENVIRONMENT = config.SENTRY_ENVIRONMENT;
    this.ENV_LABEL = config.ENV_LABEL;
  }

  public static provide(config: AppConfig): Provider {
    return {
      provide: ConfigService,
      useValue: new ConfigService(config)
    };
  }

}
